<template>
  <div class="prgrid-container">
    <loading-spinner v-if="loading" />
    <template v-else>
      <table v-if="!empty" class="pending-replacements-table mds-data-table">
        <thead class="mds-data-table__header prgrid-header">
          <tr class="mds-data-table__row">
            <th class="mds-data-table__header-cell" scope="col">Client/Product/Fund</th>
            <th class="mds-data-table__header-cell" scope="col" style="width:11%">Ticker</th>
            <th class="mds-data-table__header-cell" scope="col" style="width:10%">SecID</th>
            <th class="mds-data-table__header-cell" scope="col" style="width:15%">Category</th>
            <th class="mds-data-table__header-cell" scope="col" style="width:8%">menus</th>
            <th class="mds-data-table__header-cell" scope="col" style="width:15%">Date of Change</th>
            <th class="mds-data-table__header-cell" scope="col" style="width:8%"></th>
          </tr>
          <tr class="mds-data-table__row shaded-row">
            <th class="mds-data-table__header-cell" scope="colgroup" colspan="7">
              <label
                class="mds-form__checkbox"
                for="select-all-clients"
                v-if="localPolicyOptions.options['submit-to-production']"
              >
                <input
                  type="checkbox"
                  id="select-all-clients"
                  class="mds-form__checkbox-input"
                  name="checkbox-name"
                  value="indeterminate-checkbox"
                  ref="selectAllClients"
                  @click="selectAllClients"
                />
                <span class="mds-form__checkbox-visible-wrap">
                  <span class="mds-form__checkbox-visual">
                    <svg class="mds-icon mds-form__checkbox-checked-icon" aria-hidden="true">
                      <use xlink:href="static/mds/icons/mds.svg#check--s"></use>
                    </svg>
                    <svg class="mds-icon mds-form__checkbox-indeterminate-icon" aria-hidden="true">
                      <use xlink:href="static/mds/icons/mds.svg#minus--s"></use>
                    </svg>
                  </span>
                  <span class="mds-form__checkbox-text">Apply to all</span>
                </span>
              </label>
            </th>
          </tr>
        </thead>
        <tbody class="mds-data-table__body prgrid-content">
          <tr class="mds-data-table__row" v-for="(client, index) in getClientsData" :key="index">
            <td class="mds-data-table__cell" colspan="7">
              <table class="pending-replacements-table-client mds-data-table">
                <thead class="mds-data-table__header">
                  <tr class="mds-data-table__row">
                    <th class="mds-data-table__header-cell" scope="col">
                      <label
                        class="mds-form__checkbox"
                        :for="merge('select-client', index)"
                        v-if="localPolicyOptions.options['submit-to-production']"
                      >
                        <input
                          type="checkbox"
                          :id="merge('select-client', index)"
                          class="mds-form__checkbox-input"
                          name="checkbox-name"
                          :checked="checkSelectedClient(client.id)"
                          @change="toggleSelectedClient(client.id)"
                        />
                        <span class="mds-form__checkbox-visible-wrap">
                          <span class="mds-form__checkbox-visual">
                            <svg class="mds-icon mds-form__checkbox-checked-icon" aria-hidden="true">
                              <use xlink:href="static/mds/icons/mds.svg#check--s"></use>
                            </svg>
                            <svg
                              class="mds-icon mds-form__checkbox-indeterminate-icon"
                              aria-hidden="true"
                            >
                              <use xlink:href="static/mds/icons/mds.svg#minus--s"></use>
                            </svg>
                          </span>
                          <span class="mds-form__checkbox-text">{{ client.clientName }}</span>
                        </span>
                      </label>
                    </th>
                  </tr>
                </thead>
                <tbody class="replacement-lineups-table mds-data-table__body">
                  <tr
                    class="mds-data-table__row"
                    v-for="(product, index) in client.products"
                    :key="index"
                  >
                    <td class="mds-data-table__cell pending-replacement-lineup">
                      <button
                        class="mds-button mds-button--flat pending-replacement-lineup-name"
                        type="button"
                        @click="toggleProducts(product.id)"
                      >
                        <svg
                          class="mds-icon mds-button__icon mds-button__icon--left"
                          aria-hidden="true"
                        >
                          <use :xlink:href="setTriangle(products[product.id])">
                            <title>open/close indicator</title>
                          </use>
                        </svg>
                        <span>{{ product.productName }} ({{ product.productCode }})</span>
                      </button>
                      <transition name="scale">
                        <div class="replacement-lineups-list" v-show="products[product.id] === true">
                          <table
                            class="replacement-lineups-item"
                            v-for="(fund, index) in product.removedFunds"
                            :key="index"
                          >
                            <tr class="fund-line">
                              <td class="fund-status">
                                <status-icons :status="[{ name: getStatus(fund) }]" />
                              </td>
                              <td class="fund-name">
                                {{ fund.displayName }}
                              </td>
                              <td class="fund-ticker" style="width:10%">{{ fund.ticker }}</td>
                              <td class="fund-secid" style="width:14%">{{ fund.secId }}</td>
                              <td class="fund-category" style="width:16%">{{ fund.psaCategory.name }}</td>
                              <td style="width:10%"></td>
                              <td class="fund-date" style="width:12%">
                                {{ formatDate(fund.dateOfChange) }}
                              </td>
                              <td class="fund-action" style="width:4%"></td>
                            </tr>
                            <tr class="fund-line">
                              <td class="fund-status">
                                <status-icons :status="[{ name: getStatus(fund.replacement) }]" />
                              </td>
                              <td class="fund-name">{{ fund.replacement.displayName }}</td>
                              <td class="fund-ticker" style="width:10%">{{ fund.replacement.ticker }}</td>
                              <td class="fund-secid" style="width:14%">{{ fund.replacement.secId }}</td>
                              <td class="fund-category" style="width:17%">
                                {{ fund.replacement.psaCategory.name }}
                              </td>
                              <td class="fund-menu" style="width:10%">
                                <template v-if="fund.menus && fund.menus.length > 0">
                                  <span v-if="fund.menus.length === 1">
                                    {{fund.menus[0].menuName}}
                                  </span>
                                  <span v-if="fund.menus.length > 1" class="mds-link"
                                  @click="showMenus(fund)">
                                  Multiple
                                  </span>
                                </template>
                              </td>
                              <td class="fund-date" style="width:12%">
                                {{ formatDate(fund.replacement.dateOfChange) }}
                              </td>
                              <td class="fund-action" style="width:4%">
                                <button
                                  class="mds-button mds-button--icon-only undo-button"
                                  @mouseover="$emit('showToolTip', $event, ['Undo'])"
                                  @mouseleave="$emit('hideToolTip')"
                                  @click="undoReplacement(product, fund)"
                                >
                                  <svg aria-hidden="true" class="mds-icon mds-button__icon">
                                    <use
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xlink:href="static/mds/icons/mds.svg#undo"
                                    ></use>
                                  </svg>
                                </button>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </transition>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="empty" class="emptyGrid">
        Changes to replacements have not been added
      </div>
    </template>
  </div>
</template>
<script>
import LoadingSpinner from '@/components/atoms/LoadingSpinner';
import StatusIcons from '@/components/atoms/StatusIcons';
import { mapState, mapActions } from 'vuex';
import {
  get,
  map,
  each,
  findIndex,
  orderBy,
  sortBy,
  debounce,
} from 'lodash';
import { getPendingReplacementsData } from '@/services/PendingReplacements';

export default {
  name: 'pending-replacements-grid-new',
  components: {
    LoadingSpinner,
    StatusIcons,
  },
  data() {
    return {
      loading: false,
      clients: [],
      clientsFiltered: [],
      selectedClients: [],
      products: {},
      fundsCount: 0,
      formattedFunds: {},
      empty: false,
    };
  },
  computed: {
    ...mapState({
      policies: (state) => state.user.policies,
      selectedFiduciary: (state) => state.user.fiduciary.id,
      selectedClient: (state) => state.pending.client.selected,
      selectedTab: (state) => state.pending.tab,
      needsReloading: (state) => state.pending.needsReloading,
      searchTerm: (state) => state.pending.searchTerm,
    }),
    currentViewName() {
      return this.selectedClient > 0 ? 'one-client' : 'all-clients';
    },
    localPolicyOptions() {
      return get(this.policies, `pending.views.${this.currentViewName}.tabs.${this.selectedTab}`);
    },
    getClientsData() {
      if (this.searchTerm) {
        return this.clientsFiltered;
      }

      this.resetFilter();
      return this.clients;
    },
  },
  mounted() {
    this.updateData();
  },
  watch: {
    selectedClients(newVal) {
      const selectedFunds = [];
      map(this.selectedClients, (client) => {
        selectedFunds.push(...this.formattedFunds[client]);
      });
      this.$emit('updateSelected', selectedFunds);
      if (!this.empty) {
        if (newVal.length === 0) {
          this.$refs.selectAllClients.checked = false;
          this.$refs.selectAllClients.indeterminate = false;
          return;
        }
        if (newVal.length > 0 && newVal.length < this.clients.length) {
          this.$refs.selectAllClients.checked = false;
          this.$refs.selectAllClients.indeterminate = true;
          return;
        }
        if (newVal.length === this.clients.length) {
          this.$refs.selectAllClients.checked = true;
          this.$refs.selectAllClients.indeterminate = false;
        }
      }
    },
    needsReloading(newValue) {
      if (newValue === true) {
        this.selectedClients = [];
        this.$store.dispatch('setReloadNeed', false);
        this.updateData();
      }
    },
    selectedClient() {
      this.selectedClients = [];
      this.updateData();
    },
    searchTerm() {
      this.loading = true;
      this.debounceSearchTerm();
    },
  },
  methods: {
    ...mapActions(['setPendingItemsDisplayed', 'setPendingItemsSelected']),
    merge(name, index) {
      return `${name}-${index}`;
    },
    toggleProducts(id) {
      this.products[id] = !this.products[id];
    },
    toggleSelectedClient(id) {
      const found = findIndex(this.selectedClients, (item) => item === id);
      if (found > -1) {
        this.selectedClients.splice(found, 1);
      } else {
        this.selectedClients.push(id);
      }
    },
    checkSelectedClient(id) {
      return findIndex(this.selectedClients, (item) => item === id) > -1;
    },
    checkProduct(id) {
      return this.products[id];
    },
    getStatus(fund) {
      if (fund.pendingStatus) {
        return fund.pendingStatus.name;
      }
      return fund.fundStatus.name;
    },
    formatDate(date) {
      const d = new Date(date);
      const daysOfTheWeek = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      return `${daysOfTheWeek[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
    },
    setTriangle(value) {
      if (value === false) {
        return 'static/mds/icons/mds.svg#triangle-fill-right';
      }
      return 'static/mds/icons/mds.svg#triangle-fill-down';
    },
    selectAllClients() {
      // If the selected list is not complete, fill it
      if (this.selectedClients.length < this.clients.length) {
        this.selectedClients = [];
        this.clients.map((item) => {
          this.selectedClients.push(item.id);
          return item;
        });
      } else {
        this.selectedClients = [];
      }
    },
    undoReplacement(product, fund) {
      this.$store.dispatch('openModal', {
        title: 'Undo Replacement',
        component: 'undo-replacements-new',
        data: {
          product,
          fund,
        },
      });
    },
    updateData() {
      /* eslint-disable no-param-reassign */
      this.loading = true;
      this.fundsCount = 0;
      let url = '';
      this.clients = [];

      // call API endpoint
      if (this.selectedClient === 0) {
        url = `/fiduciaries/${this.selectedFiduciary}/pending-replacements/V2`;
      } else {
        url = `/fiduciary-clients/${this.selectedClient}/pending-replacements/V2`;
      }
      getPendingReplacementsData({
        url,
      }).then((result) => {
        if (this.selectedClient === 0) {
          this.clients = sortBy(result.data.fiduciaryClients, ['clientName'], ['asc']);
        } else if (result.data.clientName) {
          this.clients[0] = result.data;
        }
        if (this.clients.length > 0) {
          this.empty = false;
          each(this.clients, (client) => {
            client.products = orderBy(client.products, ['productName'], ['asc']);
            this.formattedFunds[client.id] = [];
            each(client.products, (product) => {
              this.$set(this.products, product.id, false);
              this.fundsCount += product.removedFunds.length;
              const productId = product.id;
              map(product.removedFunds, (removedFund) => {
                this.formattedFunds[client.id].push({
                  productId,
                  fiduciaryFundId: removedFund.id,
                  replacementFiduciaryFundId: removedFund.replacement.id,
                  menuIds: removedFund.menus,
                });
              });
            });
          });
          this.$store.dispatch('setPendingItemsDisplayed', this.fundsCount);
        } else {
          this.empty = true;
        }
      }).catch((err) => {
        if (err.status === 401) {
          this.$router.push('/Login');
        }
      }).finally(() => {
        this.loading = false;
      });
      /* eslint-enable no-param-reassign */
    },
    checkFilters(product) {
      let result = false;
      product.forEach((fund) => {
        if (fund !== null) {
          result = true;
        }
      });
      return result;
    },
    resetFilter() {
      this.clientsFiltered = [];
      this.clients.forEach((client) => {
        client.products.forEach((product) => {
          this.products[product.id] = false;
        });
      });
    },
    setClientsFilter() {
      if (!this.searchTerm) {
        this.loading = false;
        return;
      }

      const findByProperty = (funds, property) => {
        const regE = new RegExp(this.searchTerm, 'gi');
        return funds.find((fund) => fund[`${property}`].match(regE) ?? fund.replacement[`${property}`]?.match(regE));
      };

      this.clientsFiltered = this.clients.reduce((filterListClients, client) => {
        const productsMatchSearch = client.products.reduce((accProductsMatchSearch, product) => {
          const isByName = !!(findByProperty(product.removedFunds, 'displayName'));
          const isBySecId = !!(findByProperty(product.removedFunds, 'secId'));
          const isByTicker = !!(findByProperty(product.removedFunds, 'ticker'));

          return isByName || isBySecId || isByTicker
            ? [...accProductsMatchSearch, product]
            : accProductsMatchSearch;
        }, []);

        productsMatchSearch.forEach((product) => {
          this.products[product.id] = true;
        });

        return productsMatchSearch.length ? [...filterListClients, client] : filterListClients;
      }, []);

      this.loading = false;
    },
    debounceSearchTerm: debounce(function debounceSearchTerm() {
      this.setClientsFilter();
    }, 700),
    showMenus(fundData) {
      const fund = fundData.replacement.displayName;
      const { menus } = fundData;
      this.$store.dispatch('openFullscreenModal', {
        title: 'Menu List',
        component: 'menu-list',
        data: {
          fund,
          menus,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.prgrid-container {
  display: flex;
  flex-direction: column;
  .prgrid-header {
    padding-bottom: 10px;
  }
  .mds-form__checkbox-text {
    font-size: $mds-font-size-m;
    font-weight: $mds-font-weight-light;
    color: $mds-color-neutral-12;
  }
  .mds-data-table__cell {
    border-top: none;
  }
  input[type="checkbox"] {
    visibility: hidden;
  }
  .pending-replacements-table {
    flex: 0 1 auto;
    tbody {
      overflow: auto;
      width: 100%;
      height: auto;
    }
  }
  .pending-replacements-table {
    .mds-data-table__header-cell {
      padding: $mds-space-inset-2-x;
      font-weight: $mds-font-weight-bold;
    }
  }
  .pending-replacements-table-client {
    .mds-data-table__header-cell {
      padding: $mds-space-inset-2-x;
    }
  }
  .replacement-lineups-table {
    .pending-replacement-lineup {
      padding: $mds-space-inset-1-x $mds-space-inset-2-x;
      border-bottom: 1px solid $mds-color-neutral-90;
      .pending-replacement-lineup-name {
        padding: $mds-space-inset-1-x $mds-space-inset-2-x;
        @include mds-body-text-m();
        font-weight: $mds-font-weight-bold;
      }
    }
    tr.mds-data-table__row:first-child td.pending-replacement-lineup {
      padding-top: 0;
    }
    .replacement-lineups-list {
      margin: $mds-space-inset-2-x $mds-space-inset-4-x;
      .replacement-lineups-item {
        width: 100%;
        padding: $mds-space-inset-1-x $mds-space-inset-2-x;
        background-color: $mds-color-neutral-95;
        margin-bottom: $mds-space-inset-2-x;
        .fund-line {
          width: 100%;
          td {
            padding: $mds-space-inset-1-x 0;
          }
          .fund-action {
            text-align: right;
            padding: 0;
          }
          .undo-button {
            background-color: $mds-color-neutral-90;
            border-radius: 6px;
            width: 32px;
            height: 32px;
          }
        }
        &:hover {
          background-color: #f2fbff;
          & .undo-button {
            background-color: #e0f3fb;
          }
        }
      }
    }
  }
  .shaded-row {
    background-color: $mds-color-neutral-95;
    .mds-form__checkbox-text {
      color: $mds-color-black;
    }
  }
  .emptyGrid {
    @include mds-level-1-heading();
    font-weight: $mds-font-weight-thin;
    color: $mds-text-color-primary-on-light;
    text-align: center;
    width: 50%;
    margin: 100px auto;
  }
}
</style>
